import { clone as _clone, merge as _merge, forEach as _forEach } from 'lodash';
import {
    ADD_RSVP,
    REMOVE_RSVP,
    EDIT_EVENT,
    CREATE_EVENT,
    CLEAR_EVENTS,
    GET_ALL_RSVPS,
    GET_ONE_EVENT,
    GET_ALL_EVENTS,
    GET_SINGLE_RSVPS,
    EVENT_ADD_KEYS_FOR_RADIUS,
    EVENT_CLEAR_RADIUS
} from '../constants/event.js';

export const initialState = {
    rsvps: {},
    events: {},
    radiusEventIDs: []
};

export function eventsReducer( state = initialState, action ) {

    let events, rsvps;

    switch ( action.type ) {

        case EVENT_ADD_KEYS_FOR_RADIUS:
            return Object.assign( {}, state, {
                radiusEventIDs: action.eventIDs
            });

        case EVENT_CLEAR_RADIUS:
            return Object.assign( {}, state, {
                radiusEventIDs: {}
            });

        // Prepare for a stream of search actions
        case CLEAR_EVENTS:
            return Object.assign( {}, state, {
                rsvps: {},
                events: {}
            });

        case CREATE_EVENT:
        case EDIT_EVENT:
        case GET_ONE_EVENT:

            events = _clone( state.events );
            events[ action.index ] = _merge( events[ action.index ], action.event );
            events[ action.index ].id = action.index;

            return Object.assign( {}, state, {
                events
            });

        case GET_ALL_EVENTS:
            events = action.events;
            return Object.assign( {}, state, {
                events
            });

        case ADD_RSVP:
        case REMOVE_RSVP:
        case GET_SINGLE_RSVPS:
            rsvps = _clone( state.rsvps );
            events = _clone( state.events );
            rsvps[ action.index ] = action.rsvps;
            events[ action.index ].rsvps = action.rsvps;

            return { ...state, events, rsvps };

        case GET_ALL_RSVPS:

            events = _clone( state.events );

            _forEach( action.rsvps, ( rsvpList, eventID ) => {
                if ( typeof events[ eventID ] !== 'undefined' ) {
                    events[ eventID ].rsvps = rsvpList;
                }
            });

            rsvps = action.rsvps;

            return { ...state, events, rsvps };

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/events.js